<template>
  <!-- Footer -->
  <footer class="footer footer-eight">
			
			<!-- Footer Top -->
			<div class="footer-top aos" data-aos="fade-up">
				
				<div class="container">
					<div class="row">
						<div class="col-xl-3 col-lg-5 col-md-4 col-sm-6">
							<!-- Footer Widget -->
							<div class="footer-widget">
								<div class="footer-logo">
									<router-link to="/home/"><img src="@/assets/img/logo.svg" alt="logo"></router-link>
								</div>
								<p>Contrary to popular belief, Lorem Ipsum is not simply random text. </p>
								<div class="footer-contact-info">
									<p><span><i class="feather-phone"></i></span> 321-546-8764</p>
									<p ><span><i class="feather-mail"></i></span>support@example.com</p>
									<div class="footer-address">
										<p><span><i class="feather-map-pin"></i></span>706 Campfire Ave. Meriden, CT 06450</p>
									</div>
								</div>
								<div class="social-icon">
									<ul class="flex-wrap">
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-google"></i> </a>
										</li>
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-facebook"></i> </a>
										</li>
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-twitter"></i> </a>
										</li>
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-instagram"></i></a>
										</li>
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-linkedin"></i></a>
										</li>
										<li>
											<a href="javascript:void(0);"><i class="ti ti-brand-whatsapp"></i> </a>
										</li>
									</ul>
								</div>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu-8 footer-menu-eight">
								<h2 class="footer-title">Support</h2>
								<ul>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<router-link to="/pages/contact-us">Contact us</router-link>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Online Chat</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Whatsapp</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Telegram</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Ticketing</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Call Center</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-xl-2 col-lg-4 col-md-4 col-sm-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu-8 footer-menu-eight">
								<h2 class="footer-title">About Us</h2>
								<ul>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<router-link to="/pages/about-us">About us</router-link>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<router-link to="/blogs/blog-grid">Blog</router-link>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Careers</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Jobs</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">In Press</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Gallery</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-menu-8 footer-menu-eight">
								<h2 class="footer-title">Top Cities</h2>
								<ul>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Manhattan</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Los Angels</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Chicago</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Alabama</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Houston</a>
									</li>
									<li>
										<img src="@/assets/img/icons/mini-pink-feet.svg" alt="image">
										<a href="javascript:void(0);">Newyork</a>
									</li>
								</ul>
							</div>
							<!-- /Footer Widget -->
						</div>
						<div class="col-xl-3 col-lg-3 col-md-6">
							<!-- Footer Widget -->
							<div class="footer-widget footer-side footer-menu-eight">
								<h2 class="footer-title">Application</h2>
								<p>The platform is straightforward, allowing users to post tasks and receive  from local </p>
								<div class="app-eight-bottom d-flex mb-4">
									
										<a href="javascript:void(0);" class="app-eight-content-inner me-2">
											<img src="@/assets/img/icons/app-store.svg" alt="image">
										</a>
										<a href="javascript:void(0);">
											<img src="@/assets/img/icons/goolge-play.svg" alt="image">
										</a>
									
								</div>
								<h6 class="mb-2">Newsletter</h6>
								<div class="subscribe-form mb-4">
									
									<input type="email" class="form-control" placeholder="Enter Email Address">
									<button type="submit" class="btn footer-btn btn-primary d-flex justify-content-center align-items-center">
										<i class="feather-send"></i>
									</button>
								</div>
							</div>
							<!-- /Footer Widget -->
						</div>
					</div>
				</div>
			</div>
			<!-- /Footer Top -->
			
			<!-- Footer Bottom -->
			<div class="footer-bottom footer-bottom-eight">
				<div class="container">
					<div class="copyright">
						<div class="row text-center">
							<div class="col-md-12">
								<div class="copyright-text">
									<p>Copyright 2024 © Truelysell. All right reserved.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /Footer Bottom -->
			
		</footer>
		<!-- /Footer -->
</template>